import AirDatepicker from 'air-datepicker';
import localesFr from 'air-datepicker/locale/fr';

class CornerAcutality {
  constructor() {
    this._init();
  }
  _init() {
    // 1. Récupérer les éléments du DOM
    // On utilise un "type assertion" (<HTMLSelectElement>) pour que TypeScript sache
    // que ces éléments sont bien des listes déroulantes.
    const communeSelect = document.getElementById(
      'commune-select'
    ) as HTMLSelectElement;
    const typeSelect = document.getElementById(
      'type-select'
    ) as HTMLSelectElement;

    // console.log(typeSelect);
    // Vérification de sécurité : s'assurer que les éléments existent avant d'aller plus loin
    if (!communeSelect || !typeSelect) {
      // console.error(
      //   "Impossible de trouver les éléments 'commune-select' ou 'type-select'."
      // );
      return; // Arrête l'exécution du script si un élément manque
    }

    // 2. Fonction pour recharger la page avec les filtres
    const reloadPageWithFilters = () => {
      // Récupère les valeurs actuelles des deux select
      const communeValue = communeSelect.value;
      const typeValue = typeSelect.value;

      // Utilise l'API URLSearchParams pour construire proprement les paramètres de l'URL
      const params = new URLSearchParams(window.location.search);

      // Met à jour les paramètres. Si la valeur est vide, le paramètre est ajouté sans valeur (ex: ?commune=)
      // ce qui est souvent interprété comme "pas de filtre".
      params.set('commune', communeValue);
      params.set('type', typeValue);

      // Reconstruit l'URL complète et redirige
      // window.location.pathname -> /ma-page.html
      // params.toString() -> commune=paris&type=restaurants&date=2023-01-01
      window.location.href = `${window.location.pathname}?${params.toString()}`;
    };

    // 3. Attacher les écouteurs d'événements
    communeSelect.addEventListener('change', reloadPageWithFilters);
    typeSelect.addEventListener('change', reloadPageWithFilters);

    // 4. Initialiser les select au chargement de la page
    // Cette partie est cruciale pour que les select affichent les filtres actifs
    // si l'utilisateur arrive sur une URL contenant déjà des query params.
    const initializeFilters = () => {
      const params = new URLSearchParams(window.location.search);
      const communeParam = params.get('commune');
      const typeParam = params.get('type');

      // Si un paramètre "commune" existe dans l'URL, on sélectionne la bonne option
      if (communeParam) {
        communeSelect.value = communeParam;
      }

      // Idem pour la catégorie
      if (typeParam) {
        typeSelect.value = typeParam;
      }
    };

    // Appelle la fonction d'initialisation une fois au début
    initializeFilters();
    this._initDatePicker();
  }

  _initDatePicker() {
    const displayInput = document.getElementById('select-date-display');
    const hiddenInput = document.getElementById('select-date');

    if (displayInput && hiddenInput) {
      const selectedDates: Date[] = [];

      const dataDate = hiddenInput.getAttribute('data-date');
      const dataDateDebut = hiddenInput.getAttribute('data-date-debut');
      const dataDateFin = hiddenInput.getAttribute('data-date-fin');
      // if (dataDate) {
      //   selectedDates.push(this._parseDate(dataDate));
      // } else
      if (dataDateDebut && dataDateFin) {
        selectedDates.push(
          this._parseDate(dataDateDebut),
          this._parseDate(dataDateFin)
        );
      }
      const datepicker = new AirDatepicker(displayInput as HTMLInputElement, {
        locale: localesFr,
        range: true,
        buttons: [
          {
            content: 'Effacer',
            onClick: () => {
              (displayInput as HTMLInputElement).value = '-';
              (hiddenInput as HTMLInputElement).value = '';
              datepicker.clear();
              // Recharger la page avec la nouvelle date
              const params = new URLSearchParams(window.location.search);
              params.set('date', (hiddenInput as HTMLInputElement).value);
              window.location.href = `${window.location.pathname
                }?${params.toString()}`;
            }
          }
        ],
        onSelect: ({ date }) => {
          if (Array.isArray(date)) {
            if (date.length === 1) {
              const selectedDate = date[0];
              this._setInitialValue(
                displayInput as HTMLInputElement,
                hiddenInput as HTMLInputElement,
                [selectedDate]
              );
            } else if (date.length === 2) {
              this._setInitialValue(
                displayInput as HTMLInputElement,
                hiddenInput as HTMLInputElement,
                date
              );
              // Recharger la page avec la nouvelle date
              const params = new URLSearchParams(window.location.search);
              params.set('date', (hiddenInput as HTMLInputElement).value);
              window.location.href = `${window.location.pathname
                }?${params.toString()}`;
            }
          }
        }
      });

      if (selectedDates.length > 0) {
        this._setInitialValue(
          displayInput as HTMLInputElement,
          hiddenInput as HTMLInputElement,
          selectedDates
        );
        // TODO : Regarder pour présélectionner les dates dans le datepicker sans changer le format
        // datepicker.selectDate(selectedDates, { silent: true });
      }
    }
  }

  private _parseDate(dateString: string): Date {
    const year = parseInt(dateString.substring(0, 4));
    const month = parseInt(dateString.substring(4, 6)) - 1;
    const day = parseInt(dateString.substring(6, 8));
    return new Date(year, month, day);
  }
  private _setInitialValue(
    displayInput: HTMLInputElement,
    hiddenInput: HTMLInputElement,
    dates: Date[]
  ) {
    if (dates.length === 1) {
      displayInput.value = `Le ${this._formatDate(dates[0])}`;
      hiddenInput.value = this._formatDateForQuery(dates[0]);
    } else if (dates.length === 2) {
      displayInput.value = `Du ${this._formatDate(
        dates[0]
      )} au ${this._formatDate(dates[1])}`;
      hiddenInput.value = `${this._formatDateForQuery(
        dates[0]
      )}au${this._formatDateForQuery(dates[1])}`;
    } else {
      displayInput.value = '-';
      hiddenInput.value = '';
    }
  }
  private _formatDateForQuery(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}${month}${day}`;
  }
  private _formatDate(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
}
export const cornerAcutality = new CornerAcutality();
